export const ApiConnectionStatusConstants = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  PENDING: 'pending',
  DECLINED: 'declined'
};

export default ApiConnectionStatusConstants;
